import './index.scss';
import Template from '../../components/template';
import auth from '../../lib/auth';
import TabBar from '../../components/tab-bar';
import AccountSettingsSection from './sections/account-settings';
import StatusSection from './sections/subscription-status';
import AuthWall from '../../components/auth-wall';
import UserDownloads from './sections/downloads';
import SavedDataPage from './sections/saved-data';
import React from 'react';
import CanvasPage from './sections/canvas';


export default function UserPage() {

    return <AuthWall>
        <Template showFooter>
            <div id="user-page" className="pb-10">
                <div id="hero" className="bg-blue-gradient" >
                    <div className="text-7xl bg-gray-100 text-blue-500 rounded-full p-8">
                        <i className="icon-user" />
                    </div>
                    <div className="mx-10">
                        <h1>{auth.principal?.name}</h1>
                        <p>{auth.principal?.email}</p>
                        <p>{auth.principal?.orgs.map(org => org.name).reduce((prev, curr, idx) => idx === 0 ? curr : `${prev}, ${curr}`, '')}</p>
                    </div>
                </div>
                <TabBar useRouter useContainer justification="justify-center">
                    {[
                        {name: 'Account Settings', component: AccountSettingsSection, stub: 'account'},
                        {name: 'Saved Data', component: SavedDataPage, stub: 'saved-data'},
                        {name: 'Canvas Boards', component: CanvasPage, stub: 'canvas'},
                        {name: 'File Downloads', component: UserDownloads, stub: 'user-downloads'},
                        {name: 'Subscription Status', component: StatusSection, stub: 'status'},
                    ]}
                </TabBar>
            </div>
        </Template>
    </AuthWall>;
}